<ion-list lines="none"> 
    <ion-item button (click)="seekerProfile()">
      <ion-icon name="contact" slot="start"></ion-icon>
      <ion-label>{{'Profile' | translation}}</ion-label>
    </ion-item>
    <ion-item button *ngIf="isAssigned && false" (click)="unAssign()">
      <ion-icon name="close" slot="start"></ion-icon>
      <ion-label>{{'UnAssign' | translation}}</ion-label>
    </ion-item>
  </ion-list>